import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import { setPageMeta } from '../utils/seo';
import partnersbg from '../Assets/partnersbg.png';
import './Partners.css';

const Partners = () => {
  useEffect(() => {
    setPageMeta(
      'Partners | Sapiencia.AI',
      'Sapiencia.AI partners, certifications, and ecosystem collaborations.'
    );
  }, []);

  return (
    <div
      className="partners-page"
      style={{ backgroundImage: `url(${partnersbg})` }}
    >
      <Navbar />

      <main className="partners-content">

        {/* NVIDIA Inception Program Partnership */}
        <motion.section
          className="partner-focus-section"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.45 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <motion.h2
            className="section-heading"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.5 }}
            transition={{ duration: 0.7 }}
          >
            NVIDIA Inception Program Partnership
          </motion.h2>

          <motion.div
            className="partner-card glass-dark"
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.45 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <img
              src="/NVIDIA_logo.svg"
              alt="NVIDIA Inception Program badge"
              className="nvidia-inception-badge"
              width="180"
              height="64"
            />

            <p>
              Sapiencia.AI participates in the NVIDIA Inception program to accelerate secure AI innovation. The NVIDIA Inception program provides access to NVIDIA expertise, technical resources, and go-to-market support that strengthen our cybersecurity practice.
            </p>

            <p className="nvidia-legal">
              © 2025 NVIDIA, the NVIDIA logo, and all other trademarks mentioned in the document are trademarks and/or registered trademarks of NVIDIA Corporation in the U.S. and other countries.
            </p>
          </motion.div>
        </motion.section>

        {/* Vanta Service Provider Partner */}
        <motion.section
          className="partner-focus-section"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.45 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <motion.h2
            className="section-heading"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.5 }}
            transition={{ duration: 0.7 }}
          >
            Vanta Service Provider Partnership
          </motion.h2>

          <motion.div
            className="partner-card glass-dark"
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.45 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <img
              src="/Vanta_Partner.png"
              alt="Vanta partner logo"
              className="partner-logo"
              width="500"
              height="177"
            />

            <p>
              We are a Vanta Service Provider Partner, helping companies achieve and maintain security and compliance through expert advisory services and Vanta's automated trust management platform.
            </p>
          </motion.div>
        </motion.section>

      </main>

      <Footer />
    </div>
  );
};

export default Partners;